<template>
    <v-row>
      <v-dialog v-model="showDialog" scrollable max-width="950px" style="overflow:hidden">
        <v-skeleton-loader
        v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>
        <v-card v-if="!loading">
          <v-card-title>
            <v-col cols="6" v-if="isNew">
                  <span style="font-size: 20px;">
                     Nuevo mensaje de soporte
                  </span>
            </v-col>
            <v-col cols="3" v-if="!isNew">
                  <span style="font-size: 20px;">
                     {{ data.ticketCode}}
                  </span>
            </v-col>
            <v-col cols="9" v-if="!isNew" style="text-align: end;">
                  <span style="font-size: 20px;">
                        {{ data.lastname}}, {{ data.firstname}} - {{ data.companyName}}
                  </span>
            </v-col>
          </v-card-title>
          <v-card-text>
            <v-container @wheel="onWheel">
               <v-form ref="form">
                  <v-row>
                        <v-col cols="3" v-if="!isNew">                
                           <v-text-field
                              v-model="creationDate"
                              label="Fecha"
                              autocomplete="none"
                              disabled
                           />
                        </v-col>


                        <v-col cols="3">      
                           <v-select
                              v-model="data.ticketType"
                              :items="ticketTypes"
                              item-text="name"
                              item-value="id"
                              menu-props="bottom, offsetY"
                              label="Tipo"
                              :disabled = "!isAdmin && !isNew"
                        />
                        </v-col>

                        <v-col cols="3">   
                           <v-select
                              v-model="data.ticketPriority"
                              :items="ticketPriorities"
                              item-text="name"
                              item-value="id"
                              menu-props="bottom, offsetY"
                              label="Prioridad"
                              :disabled = "!isAdmin"
                        />
                        </v-col>


                        <v-col cols="3" v-if="!isNew">     
                           <v-select
                              v-model="data.ticketStatus"
                              :items="ticketStatuses"
                              item-text="name"
                              item-value="id"
                              menu-props="bottom, offsetY"
                              label="Estado"
                              :disabled = "!isAdmin"
                        />
                        </v-col>

                        <v-col cols="12">                
                           <v-text-field
                              v-model="data.title"
                              label="Título"
                              :disabled="isClosed"
                              autocomplete="none" counter dense
                              :rules="[validationRules.required]"
                              maxlength="100"
                           />
                        </v-col>

                        <v-col cols="12" v-if="isNew">                
                        <tiptap-vuetify 
                              v-model="newSupportTicketMessage"
                              :placeholder="editorPlaceholder"
                              :extensions="extensions" :card-props="{ flat: true }" />
                     
                        </v-col>

                        <v-col cols="12" v-if="isNew">       
                           <v-file-input
                           multiple chips truncate-length="45"
                           label="Archivos adjuntos"
                           v-model="files"
                           ></v-file-input>
                        </v-col>

                  </v-row>   
                  
                  <v-row v-if="!isNew" >

                        <v-timeline align-top dense>
                              <v-timeline-item v-for="message in messages" :key="message.id" large>
                                 <template v-slot:icon>
                                    <v-avatar>
                                       <img :src="getProfileAssetUrl(message.profilePicture)">
                                    </v-avatar>
                                 </template>
                                 <v-card class="elevation-2">
                                 <v-card-title>
                                    {{message.lastname}}, {{message.firstname}}
                                    <v-chip v-if="!message.isPublic" class="ma-2" x-small text-color="white" color="orange">Privado</v-chip>
                                 </v-card-title>
                                 <v-card-subtitle>
                                    {{formatDateTime(message.creationDate)}}
                                 </v-card-subtitle>
                                 <v-card-text>
                                    <div v-html="message.message" />
                                    <div v-if="message.files && message.files.length>0" class="pt-3">
                                       <div v-for="file in message.files" :key="file.id">
                                          <span @click="downloadDocument(message.id,file.id)" class="text--primary" style="text-decoration: underline; cursor:pointer;">{{ file.documentName }}</span>
                                       </div>
                                    </div>
                                 </v-card-text>
                                 </v-card>
                              </v-timeline-item>
                        </v-timeline>
                  </v-row>
               </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn v-if="data.id && !isClosed" color="#185EA9" @click="newMessage()" text>
                          <v-icon left>message</v-icon>
                          <span>Nuevo mensaje</span>
                      </v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="!canSendMessage || isClosed" color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
            <v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
          <SuportTicketMessageDialog :isAdmin="isAdmin" ref="newMessageDialog" v-on:refresh="showDialog=true; loadTicket(data.id)"/>
          <ConfirmDialog ref="dlgConfirm"
              v-bind:title="$t('wkt.admin.report-types.edit-report-type.confirm-dialog.title')"
              v-bind:message="$t('wkt.admin.report-types.edit-report-type.confirm-dialog.text')"
              v-bind:titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
              v-bind:titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
              v-on:confirmed="deleteItem()"
          />
    </v-row>	
  </template>
  
<script>
import BaseModule from '../../common/BaseModule.js'
import CommonFormatter from '../../common/CommonFormatter.js'
import ConfirmDialog from '../../common/ConfirmDialog'
import api from '../../../api/worktime'
import gwt from '../../../api/gwt'
import { TiptapVuetify, Bold, Italic, Strike, Underline, Code, BulletList, OrderedList, ListItem, Link, Blockquote, History } from 'tiptap-vuetify'

import SuportTicketMessageDialog from './components/SuportTicketMessageDialog'
export default {
   name: 'SupportTicketDialog',
   mixins: [BaseModule, CommonFormatter],
   components: {
      ConfirmDialog, SuportTicketMessageDialog, TiptapVuetify
   },
   data() {
      return {
         showDialog: false,
         loading: true,
         creationDate: null,
         data: {},
         isAdmin: false,
         isNew: false,
         files: null,
         newSupportTicketMessage: null,
         editorPlaceholder: 'Escribe aquí tu mensaje...',
         messages: [],
         ticketTypes: [{id:0, name:'Consulta'},
                       {id:1, name:'Sugerencia'},
                       {id:2, name:'Incidencia'}],
         ticketPriorities: [{id:0, name:'Baja'},
                       {id:1, name:'Media'},
                       {id:2, name:'Alta'},
                       {id:3, name:'Crítica'}],
         ticketStatuses: [{id:0, name:'Abierto'},
                       {id:1, name:'En curso'},
                       {id:2, name:'Pendiente respuesta'},
                       {id:3, name:'Cerrado'}],
         extensions: [
               History,
               Blockquote,
               Link,
               Underline,
               Strike,
               Italic,
               ListItem,
               BulletList,
               OrderedList,
               Bold,
               Code
            ],
      }
   },
   computed: {
      canSendMessage() {
         return !this.isNew || this.newSupportTicketMessage && this.newSupportTicketMessage.length > 20;
      },
      isClosed() {
         return !this.isAdmin && this.data && this.data.ticketStatus==3;
      }
   },
   methods: {
      onWheel(event) {
            event.stopPropagation()
        },
      newMessage: function() {
         this.showDialog=false;
         this.$refs.newMessageDialog.open(this.data.id);
      },
      downloadDocument(messageId, fileId) {
         api.downloadSupportMessageFile(this.isAdmin, this.data.id, messageId,fileId);
      },
      open: function (action, payload) {

         this.showDialog = true;

         if (this.$refs.form) {
            this.$refs.form.resetValidation();
         }

         this.isAdmin = (action =='EDIT_ADMIN');
         this.messages =[];
         this.newSupportTicketMessage= null;
         this.files = null;

         if (!payload) { // Estamos creando un elemento
            this.data = {
               companyId: gwt.getSessionProfile().companyId,
               ticketPriority: 1,
               ticketStatus: 0,
               ticketType:0
            };
            this.loading = false; 
            this.isNew = true;

            return;
         }

         this.isNew = false;
         this.loading = true;

         this.loadTicket(payload);
      },
      loadTicket(tiketId) {

         api.getSupportTicket(this.isAdmin, tiketId, res => {
            this.data = res;
            this.creationDate=this.data && this.data.creationDate ? this.formatDateTime(this.data.creationDate) : null;
            this.messages = res.messages;
            if (this.messages) {
               this.messages.sort(function(a,b){
                  return new Date(b.creationDate) - new Date(a.creationDate);
               });
            }
            this.loading = false;
         }, error => {
            this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            this.loading = false;
         })


      },
      onSave: function () {
         if (!this.$refs.form.validate()) {
            return;
         }

         const ticket = {
            id: this.data.id,
            creationDate: this.data.creationDate,
            title: this.data.title,
            description: this.data.description,
            ticketStatus: this.data.ticketStatus,
            ticketPriority: this.data.ticketPriority,
            ticketType: this.data.ticketType,
            ticketCode: this.data.ticketCode,
            trackingCode: this.data.trackingCode,
            creatorId: this.data.creatorId,
            creatorFirstname: this.data.firstname,
            creatorLastname: this.data.lastname,
            creatorUsername: this.data.username,
            creatorProfilePicture: this.data.profilePicture,
            companyId: this.data.companyId,
            companyName: this.data.companyName,
            companyLicensePlan: this.data.licensePlan,
            updateDate: new Date().getTime()
         }
         this.loading = true;
         // eslint-disable-next-line no-unused-vars
         api.storeSupportTicket(this.isAdmin,ticket,res => {
               this.loading = false;
               if (res.id) {
                  this.data = res;
                  if (this.isNew) {
                     this.createFirstMessage();
                  } else {
                     this.$emit('refresh');
                     this.showDialog = false;
                  }
               } else {
                  this.$emit('show-alert',{ text: res.message, color: 'error', timeout: 3000 });
               }
            },
            error => {
               this.$log.error(error);
               this.loading = false;
               this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            });
      },
      createFirstMessage: async function () {
       
         this.loading = true;
         try {
            const actualMessage = this.newSupportTicketMessage.replace('<a href=','<a target="_blank" href=');
            const payload = await api.buildSupportTicketMessagePayload(this.data.id, true, actualMessage, this.files);

            // eslint-disable-next-line no-unused-vars
            api.storeSupportTicketMessage(this.isAdmin, this.data.id, payload,res => {
                  this.loading = false;
                  if (res.id) {
                     this.$emit('refresh');
                     this.showDialog = false;
                  } else {
                     this.$emit('show-alert',{ text: res.message, color: 'error', timeout: 3000 });
                  }
               },
               error => {
                  this.$log.error(error);
                  this.loading = false;
                  this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
               });
         } catch (error) {
            this.$log.error(error);
            this.loading = false;
            this.$emit('show-alert',{ text: error && error.message ? error.message : error, color: 'error', timeout: 3000 });
         }
      },
      confirmDelete() {
         this.$refs.dlgConfirm.confirm(this.data);
      },
      deleteItem() {
        this.loading = true;
        // eslint-disable-next-line no-unused-vars
         api.deleteExternalDocumentCategory(this.data.id, res => {
               this.showDialog = false;
               this.loading = false;
               this.$emit('refresh');
            },
            (error) => {
               this.loading = false;
               this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            }
         );
      }
   },
}
</script>
